module.exports = __webpack_public_path__ + "static/media/Ranger_Next-Gen.dfde1342.webp";